import React from "react";
import {
  Table,
  Button,
  Card,
  CardHeader,
  CardBody,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";

const TableData = ({
  dataList,
  onEdit,
  onDelete,
  onAddClick,
  pagination, // Terima prop pagination di sini
}) => {
  const { currentPage, totalPages, totalElements, onPageChange } =
    pagination || {};

  return (
    <Card className="shadow-sm border-0">
      <CardHeader className="bg-white border-0 pt-4 d-flex justify-content-between align-items-center">
        <div>
          <h5 className="fw-bold mb-0">Daftar Perangkat Desa</h5>
          {/* <small className="text-muted">Total: {totalElements || 0} data</small> */}
        </div>
        <div className="d-flex gap-2">
          <Button color="primary" size="sm" onClick={onAddClick}>
            + Tambah Data
          </Button>
        </div>
      </CardHeader>

      <CardBody>
        <Table responsive hover striped className="align-middle">
          <thead>
            <tr>
              <th>Nama</th>
              <th>No. HP</th>
              <th>NIK</th>
              <th>Alamat Detail</th>
              <th className="text-center">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {dataList && dataList.length > 0 ? (
              dataList.map((item, index) => (
                <tr key={item.registerPetugasId || index}>
                  <td>{item.nama}</td>
                  <td>{item.nomorHp}</td>
                  <td>{item.nik}</td>
                  <td>{item.alamat}</td>
                  <td className="text-center">
                    <Button
                      color="info"
                      size="sm"
                      className="me-2 mr-2"
                      onClick={() => onEdit(item)}
                    >
                      Edit
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => onDelete(item.registerPetugasId)}
                    >
                      Hapus
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted py-4">
                  Belum ada data.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* UI Navigasi Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="small text-muted">
              Halaman {currentPage + 1} dari {totalPages}
            </div>
            <Pagination aria-label="Page navigation">
              <PaginationItem disabled={currentPage === 0}>
                <PaginationLink first onClick={() => onPageChange(0)} />
              </PaginationItem>
              <PaginationItem disabled={currentPage === 0}>
                <PaginationLink
                  previous
                  onClick={() => onPageChange(currentPage - 1)}
                />
              </PaginationItem>

              {[...Array(totalPages)].map((_, i) => (
                <PaginationItem active={i === currentPage} key={i}>
                  <PaginationLink onClick={() => onPageChange(i)}>
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              <PaginationItem disabled={currentPage === totalPages - 1}>
                <PaginationLink
                  next
                  onClick={() => onPageChange(currentPage + 1)}
                />
              </PaginationItem>
              <PaginationItem disabled={currentPage === totalPages - 1}>
                <PaginationLink
                  last
                  onClick={() => onPageChange(totalPages - 1)}
                />
              </PaginationItem>
            </Pagination>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default TableData;
